import { Table, Tabs, Space, Input, Button, Pagination, Image, Tooltip, message, Popconfirm } from 'antd';
import { useState } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss'
import { useEffect } from 'react';
import { events_list, updateEventsStatus, deleteEvents } from "@/apis/events";
import { useNavigate } from "react-router-dom";

const EventsManagement = () => {
	const navigate = useNavigate();
	const [params, setParams] = useState({
		keywords: "",
		status: 0,
	})
	const [pageParam, setPageParam] = useState({
		pageSize: 10,
		currentPage: 1,
	})
	const [total, setTotal] = useState(1000)
	const [data, setData] = useState([])
	const goToDetail = (id, link) => {
		if (link) {
			window.open(link, '_blank');
		} else {
			navigate(`/detail?id=${id}&type=EVENTS`)
		}
	};

	// 更改事件状态
	const changeEventsStatus = (id, status) => {
		updateEventsStatus({
			eventsUuid: id,
			status: status
		}).then(res => {
			message.success('操作成功')
			setPageParam({ ...pageParam, currentPage: 1 })
		}).catch(err => { })
	}

	// 删除事件
	const deleteRecord = (id) => {
		deleteEvents({
			uuid: id
		}).then(res => {
			message.success('删除成功')
			setPageParam({ ...pageParam, currentPage: 1 })
		}).catch(err => { })
	}

	const columns = [
		{
			title: "事件标题",
			key: 'title',
			dataIndex: 'title',
			width: 360,
			render: (text, record) => {
				return <Tooltip title="点击预览">
					<a href="#" onClick={() => goToDetail(record.eventsUuid, record.link)}>{text}</a>
				</Tooltip>
			},
		},
		{
			title: "描述",
			key: 'text',
			dataIndex: 'text',
			render: (text, record) => {
				return <div className={styles.desBox}>{text}</div>
			},
		},
		{
			title: "发布时间",
			key: 'phenomenonTime',
			dataIndex: 'phenomenonTime',
			width: 160,
		},
		{
			title: "作者",
			key: 'author',
			dataIndex: 'author',
			width: 120,
		},
		{
			title: "封面图片",
			key: 'img',
			width: 90,
			render: (text, record) => {
				return <Image
					width={55}
					src={process.env.REACT_APP_API_AFFIX + "/file/preview?filePath=" + record.cover.filePath}
				/>
			},
		},
		{
			title: "操作",
			key: 'opreation',
			width: 200,
			render: (text, record) => {
				return <div className={styles.btnBox}>
					{(params.status === 0 || params.status === 2) && <Button onClick={() => editor(record.eventsUuid)} size="small">编辑</Button>}
					{(params.status === 0 || params.status === 2) &&
						<Popconfirm
							title="发布事件"
							description="是否确认继续发布该条事件"
							onConfirm={() => changeEventsStatus(record.eventsUuid, 1)}
							okText="是"
							cancelText="否"
						>
							<Button size="small">发布</Button>
						</Popconfirm>
					}

					{params.status === 1 &&
						<Popconfirm
							title="发布事件"
							description="是否确认继续下架该条事件"
							onConfirm={() => changeEventsStatus(record.eventsUuid, 2)}
							okText="是"
							cancelText="否"
						>
							<Button size="small">下架</Button>
						</Popconfirm>
					}

					<Popconfirm
						title="删除事件"
						description="是否确认继续删除该条事件"
						onConfirm={() => deleteRecord(record.eventsUuid)}
						okText="是"
						cancelText="否"
					>
						<Button type="primary" size="small">删除</Button>
					</Popconfirm>
				</div>
			},
		},
	];
	const items = [
		{
			key: 0,
			label: '未发布',
			children: '',
		}, {
			key: 1,
			label: '已发布',
			children: '',
		}, {
			key: 2,
			label: '已下架',
			children: '',
		}
	];

	const getList = () => {
		events_list({
			...pageParam,
			...params
		}).then(res => {
			setTotal(res.data.total)
			setData(res.data.records)
		}).catch(err => { })
	}
	const handleKeyDown = (e) => {
		if (e.keyCode === 13) {
			setPageParam({ ...pageParam, currentPage: 1 })
		}
	}

	useEffect(() => {
		getList()
	}, [params.status, pageParam])
	const addEvents = () => {
		navigate(`add`)
	}

	const editor = (id) => {
		navigate(`add?id=${id}`)
	}

	const operations = <Button onClick={addEvents} type="primary">新增</Button>;
	return <div className={classNames('container', styles.userBox)}>
		<h3>事件管理</h3>
		<Tabs
			tabBarExtraContent={operations}
			type="card"
			defaultActiveKey={params.status}
			items={items}
			onChange={(e) => {
				setParams({ ...params, status: e })
				setPageParam({ ...pageParam, currentPage: 1 })
			}} />
		<Space.Compact className={styles.paramsBox}>
			<Input
				allowClear
				placeholder="标题"
				onKeyDown={handleKeyDown}
				onChange={(e) => {
					setParams({ ...params, keywords: e.target.value })
				}} />
			<Button type="primary" onClick={getList}>搜索</Button>
		</Space.Compact>
		<Table rowKey={record => record.eventsUuid} pagination={false} columns={columns} dataSource={data} />
		<Pagination
			align="end"
			style={{ marginTop: "20px" }}
			current={params.currentPage}
			pageSize={params.pageSize}
			total={total}
			showSizeChanger={false}
			showQuickJumper
			onChange={(page, pageSize) => {
				setPageParam({
					currentPage: page,
					pageSize: pageSize,
				});
			}}
		/>
	</div>
}
export default EventsManagement;